// extracted by mini-css-extract-plugin
export var csatScore = "_nx-5";
export var header = "_nx-1";
export var panelWrapper = "_nx-2";
export var postPreview = "_nx-3";
export var rightContent = "_nx-0";
export var wrappingText = "_nx-4";